module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.attribute.sorteditAble === false) ? _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "color": "gray",
      "font-size": ".7rem"
    }
  }, [_vm._v(_vm._s(this.attribute.label))]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  })]) : _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "color": "gray",
      "font-size": ".7rem"
    }
  }, [_vm._v(_vm._s(this.attribute.label))]), _vm._v(" "), (_vm.merchandises.categoryId === 20) ? _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    staticClass: "open-popup open-goods",
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "right",
      "color": "rgb(8, 148, 236)"
    },
    attrs: {
      "type": "text",
      "value": "点我选基因/转录本",
      "data-popup": ".popup-gene-only",
      "readonly": "",
      "unselectable": "on"
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.merchandises._attributes.ReguTech.value !== 4 && _vm.merchandises._attributes.ReguTech.value !== 3 && _vm.merchandises._attributes.ReguTech.value !== '4' && _vm.merchandises._attributes.ReguTech.value !== '3') ? _c('div', {
    staticClass: "item-inner specal"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("基因名")]), _vm._v(" "), (_vm.merchandises.categoryId === 20) ? _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.attribute.value.symbol
    }
  })]) : _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.attribute.value.symbol
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.merchandises._attributes.ReguTech.value === 4 || _vm.merchandises._attributes.ReguTech.value === 3 || _vm.merchandises._attributes.ReguTech.value === '4' || _vm.merchandises._attributes.ReguTech.value === '3') ? _c('div', {
    staticClass: "item-inner specal"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("microName")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.attribute.value.microName
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.merchandises._attributes.ReguTech.value === 4 || _vm.merchandises._attributes.ReguTech.value === 3 || _vm.merchandises._attributes.ReguTech.value === '4' || _vm.merchandises._attributes.ReguTech.value === '3') ? _c('div', {
    staticClass: "item-inner specal"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("microNo")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.attribute.value.microNo
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.merchandises._attributes.ReguTech.value !== 4 && _vm.merchandises._attributes.ReguTech.value !== 3 && _vm.merchandises._attributes.ReguTech.value !== '4' && _vm.merchandises._attributes.ReguTech.value !== '3') ? _c('div', {
    staticClass: "item-inner specal"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("基因大小")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.attribute.value.CDSSize
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item-inner specal"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("物种")]), _vm._v(" "), (_vm.attribute.value.taxName) ? _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.attribute.value.taxName
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.merchandises._attributes.ReguTech.value !== 4 && _vm.merchandises._attributes.ReguTech.value !== 3 && _vm.merchandises._attributes.ReguTech.value !== '4' && _vm.merchandises._attributes.ReguTech.value !== '3') ? _c('div', {
    staticClass: "item-inner specal "
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("转录本")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    staticStyle: {
      "font-size": ".6rem",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.attribute.value.NMID
    }
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ade18fa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/finder/FinderBox/FinderAttrGeneBox.vue
// module id = 1647
// module chunks = 8